"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const OrdersReducer_1 = require("../../orders/reducers/OrdersReducer");
const OrdersSaga_1 = tslib_1.__importDefault(require("../../orders/sagas/OrdersSaga"));
const loadOrdersModule = () => ({
    id: 'Orders',
    reducerMap: {
        orders: OrdersReducer_1.ordersReducer,
    },
    sagas: [OrdersSaga_1.default],
});
exports.default = loadOrdersModule;
